import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Content, designBaseUrl } from '../../lib/FL';
import PreviewOverlay from '../atom/PreviewOverlay';
import { ModalDispatchContext } from '../../contexts/ModalProvider';
import NewCaption from '../atom/NewCaption';
import ContentPreviewModal from '../modal/ContentPreviewModal';

import styles from './ContentCard.module.scss';
import { Icons } from './Icon';

type Props = {
  content: Content;
};

const ContentCard: React.FC<Props> = ({ content }) => {
  const dispatch = useContext(ModalDispatchContext);
  const createPreviewModal = () => <ContentPreviewModal content={content} />;

  const Thumbnail: React.FC = () => (
    <div className={styles.thumbnail}>
      {content.is_new && <NewCaption />}
      <img
        src={`${designBaseUrl}/assets_resized/formatline/design/pc/contents/${content.en_name}/catalog.png`}
        alt={content.ja_name}
        className={styles.thumbnail__img}
      />
      <PreviewOverlay />
    </div>
  );

  const NoSampleThumbnail: React.FC = () => (
    <div className={`${styles.thumbnail} ${styles.thumbnail_none}`}>
      <div className={styles.thumbnail__pre}>サンプル準備中</div>
    </div>
  );

  const CardContents: React.FC = () => (
    <>
      {content.is_public ? <Thumbnail /> : <NoSampleThumbnail />}
      <div className={styles.card__info}>
        <h2 className={styles.card__title}>{content.ja_name}</h2>
        <Icons icons={content.icons} />
        <div className={styles.card__description}>{content.description}</div>
        <div className={styles.card__price}>
          <span className={styles.card__price_num}>{content.price?.toLocaleString()}</span>
          <span className={styles.card__price_unit}>円</span>
        </div>
      </div>
    </>
  );

  const CardContentsWithLink: React.FC = () => (
    <>
      <button
        className={`${styles.card__button} ${styles.card__button_pc} onMouseShowPreviewOverlay`}
        onClick={() => dispatch(createPreviewModal)}
        type='button'
      >
        <CardContents />
      </button>
      <Link
        className={`${styles.card__button} ${styles.card__button_sp}`}
        to={`/content/${content.en_name}`}
        target='_blank'
      >
        <CardContents />
      </Link>
    </>
  );

  const CardContentsWithoutLink: React.FC = () => (
    <div className={styles.card__button}>
      <CardContents />
    </div>
  );

  return <li className={styles.card}>{content.is_public ? <CardContentsWithLink /> : <CardContentsWithoutLink />}</li>;
};

export default ContentCard;
